/**
 * Formata data ISO (YYYY-MM-DD ou YYYY-MM-DDTHH:mm:ss) para DD/MM/YYYY
 * SEM usar new Date() para evitar bug de timezone (UTC → BRT = dia anterior)
 */
export function formatDateBR(val) {
  if (!val) return '—';
  const str = String(val);
  // Pega os primeiros 10 caracteres (YYYY-MM-DD)
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '—';
  return `${match[3]}/${match[2]}/${match[1]}`;
}
